/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Got_ItInputs */

const en_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Got it`)
};

const ar_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فهمت`)
};

const de_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verstanden`)
};

const es_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entendido`)
};

const fr_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compris`)
};

const it_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ho capito`)
};

const ja_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ko_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알겠어요`)
};

const pt_br_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entendi`)
};

const ru_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Понятно`)
};

const th_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าใจแล้ว`)
};

const tr_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anladım`)
};

const zh_cn_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`知道了`)
};

const zh_tw_btn_got_it = /** @type {(inputs: Btn_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`知道了`)
};

/**
* | output |
* | --- |
* | "Got it" |
*
* @param {Btn_Got_ItInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_got_it = /** @type {((inputs?: Btn_Got_ItInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Got_ItInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_got_it(inputs)
	if (locale === "ar") return ar_btn_got_it(inputs)
	if (locale === "de") return de_btn_got_it(inputs)
	if (locale === "es") return es_btn_got_it(inputs)
	if (locale === "fr") return fr_btn_got_it(inputs)
	if (locale === "it") return it_btn_got_it(inputs)
	if (locale === "ja") return ja_btn_got_it(inputs)
	if (locale === "ko") return ko_btn_got_it(inputs)
	if (locale === "pt_br") return pt_br_btn_got_it(inputs)
	if (locale === "ru") return ru_btn_got_it(inputs)
	if (locale === "th") return th_btn_got_it(inputs)
	if (locale === "tr") return tr_btn_got_it(inputs)
	if (locale === "zh_cn") return zh_cn_btn_got_it(inputs)
	return zh_tw_btn_got_it(inputs)
});